import React from 'react'
import classNames from 'classnames'

export const SkLabel = (props: { label: React.ReactNode; required?: boolean; className?: string }) => (
  <div className="ant-form-item-label">
    <label className={classNames(props.className, { 'ant-form-item-required': props.required })}>{props.label}</label>
  </div>
)
